import { useTranslation } from 'react-i18next';

import { TENANT_CONST } from '@/constant';
import { useUnleash } from '@/package';

const FREETIER_PLAN = TENANT_CONST.PLAN_BY_TIER[TENANT_CONST.TIER.FREETIER];
const STANDARD_PLAN = TENANT_CONST.PLAN_BY_TIER[TENANT_CONST.TIER.STANDARD];

export const usePlan = (customerAWSAccountId?: Nullish<string>) => {
  const { t } = useTranslation();
  const { getVariant } = useUnleash();
  const disabledAWSSignUpFlag =
    getVariant('vuex.sapporo.disabledAWSSignUp')?.feature_enabled ?? false;

  const freetier = {
    plan: t(FREETIER_PLAN.name),
    pay: t(FREETIER_PLAN.pay),
    descriptions: FREETIER_PLAN.description.map(v => t(v)),
  };

  const enterprise = {
    plan: t(STANDARD_PLAN.name),
    pay: t(STANDARD_PLAN.pay),
    descriptions: STANDARD_PLAN.description.map(v => t(v)),
  };

  return disabledAWSSignUpFlag
    ? [freetier, enterprise]
    : customerAWSAccountId
      ? [freetier, enterprise]
      : [freetier];
};
